import { useDispatch } from 'react-redux';
import { setPeriodOffset } from 'redux/reducers/meteorologyWeatherSeasonalForecastControlPanelReducer';
import useSelectionPeriods from 'hooks/Meteorology/Weather/SeasonalForecast/useSelectionPeriods';

export default function useSliderProps() {
  const {
    isMonthly, monthPeriods, trimesterPeriods,
  } = useSelectionPeriods();
  const dispatch = useDispatch();

  let maxValue;
  if (isMonthly) {
    maxValue = monthPeriods.length > 0 ? monthPeriods.length - 1 : 0;
  } else {
    maxValue = trimesterPeriods.length > 0 ? trimesterPeriods.length - 1 : 0;
  }

  return {
    sliderMax: maxValue,
    sliderMin: 0,
    sliderOnChange: (value) => dispatch(setPeriodOffset(value)),
  };
}
